// Centralized resort constants
export const HOTLINE = "+8801344089779";
export const HOTLINE_DIGITS = "8801344089779";
export const HOTLINE_DISPLAY = "+88 01344 089 779";
export const WHATSAPP_BASE = `https://wa.me/${"8801344089779"}`;
export const WHATSAPP_CATALOG = "https://wa.me/c/8801344089779";
// Curated WhatsApp product links
export const WA_NEARBY_ATTRACTIONS = "https://wa.me/p/25428917110063536/8801344089779";
export const WA_FOOD_MENU = "https://wa.me/p/26545696245117632/8801344089779";
export const FACEBOOK_URL = "https://www.facebook.com/naljuriinn";
export const FACEBOOK_REEL = "https://www.facebook.com/share/r/1AqxmSZq8M/";
export const YOUTUBE_URL = "https://www.youtube.com/@NaljuriinnOfficial";
export const INSTAGRAM_URL = "https://www.instagram.com/naljuri";
export const EMAIL = "naljuriinn@gmail.com";
export const WEBSITE = "https://www.naljuriinn.com";

// OTA listings — guests can also reserve via these channels
export const OTA = [
  { name: "Booking.com", url: "https://www.booking.com/searchresults.html?ss=Naljuri+Inn+Jaflong" },
  { name: "Airbnb",      url: "https://www.airbnb.com/s/Naljuri--Jaflong--Sylhet" },
  { name: "Expedia",     url: "https://www.expedia.com/Hotels-Search?destination=Naljuri+Jaflong+Sylhet" },
  { name: "Agoda",       url: "https://www.agoda.com/search?city=Sylhet+Bangladesh&q=Naljuri+Inn" },
  { name: "Google Hotels", url: "https://www.google.com/travel/hotels?q=Naljuri+Inn+Jaflong" },
];

export const buildWhatsAppLink = (text) =>
  `${WHATSAPP_BASE}?text=${encodeURIComponent(text || "Hello Naljuri Inn, I'd like to inquire about a stay.")}`;
